import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  input,
  signal,
  ChangeDetectionStrategy
} from '@angular/core'

@Component({
  selector: 'lla-image-lightbox',
  templateUrl: './image-lightbox.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ImageLightboxComponent implements OnInit {
  images = input.required<string[]>()
  // Optional, parallel to images
  captions = input<string[]>([])
  initialIndex = input(0)

  @Output() closed = new EventEmitter<void>()

  protected index = signal(0)

  ngOnInit(): void {
    this.index.set(this.initialIndex())
  }

  protected move(delta: number, event?: Event) {
    event?.stopPropagation()
    const count = this.images().length
    if (count === 0) {
      return
    }
    this.index.update((i) => (i + delta + count) % count)
  }

  @HostListener('document:keydown', ['$event'])
  protected onKeydown(event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape':
        this.closed.emit()
        break
      case 'ArrowLeft':
        this.move(-1)
        break
      case 'ArrowRight':
        this.move(1)
        break
    }
  }
}
